(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReplaceTimeOrderBagServiceItemDialogV2Controller', ReplaceTimeOrderBagServiceItemDialogV2Controller);

    ReplaceTimeOrderBagServiceItemDialogV2Controller.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OrderBagServiceItemCustom', 'ServiceTimeSessionCustom', 'ServiceTimeSession', 'ScheduleInfoCustom'];

    function ReplaceTimeOrderBagServiceItemDialogV2Controller($timeout, $scope, $stateParams, $uibModalInstance, entity, OrderBagServiceItemCustom, ServiceTimeSessionCustom, ServiceTimeSession, ScheduleInfoCustom) {

        var vm = this;
        vm.orderBagItemId = entity.orderBagItemId;
        vm.serviceItemId = entity.serviceItemId;
        vm.currentTime = entity.currentTime;
        vm.clear = clear;
        vm.save = save;
        //vm.availableDates = [];
        vm.selectedTimeSessionId = null;
        vm.availableDates_changed = availableDates_changed;


        loadAvailableDates();
        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {

            if (vm.selectedTimeSessionId == null || vm.orderBagItemId == null) {
                return;
            } else {
                OrderBagServiceItemCustom.replaceTime(vm.orderBagItemId, vm.selectedTimeSessionId).query()
                    .$promise.then(onSaveSuccess());
            }
        }

        function onSaveSuccess() {
            //$scope.$emit('tikonApp:orderBagServiceItemUpdate', result);

            vm.result = ServiceTimeSession.get({id: vm.selectedTimeSessionId}).$promise
            $uibModalInstance.close(vm.result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function loadAvailableDates() {

            if (vm.serviceItemId == undefined || vm.serviceItemId == null) {
                // error
                // have to evaluate
                return;
            }
            vm.availableDates = [];
            //ServiceTimeSessionCustom.getServiceTimeSessionFromNow(vm.serviceItemId).query(function(data)
            //{
            //    vm.availableDates=data;
            //});
            var dates = ServiceTimeSessionCustom.getServiceTimeSessionFromNow(vm.serviceItemId).query(function (result) {
                angular.forEach(dates, function (d) {


                    if (d.capacity > 0) {

                        var similarDate = vm.availableDates.filter(function (d2) {
                            if (d2.date == d.startDate)
                                return d2;
                        })
                        if (similarDate.length == 0) {
                            vm.availableDates.push({date: d.startDate});
                        }
                    }

                });

            });

        }

        function loadAvailableDynamicDate() {
            vm.availableDynamicDates = ScheduleInfoCustom.getDynamicAvailableDatesByServiceIdAndServantId(vm.orderBagServiceItem.serviceItemId, getServantId()).query(function (list) {
                if (list[0])
                    vm.selectedDynamicDate = list[0].spanDate;
                if (then)
                    then();
                $ctrl.updateAvailableFromTime(then);

            });
        }

        function getServantId() {
            if (vm.orderBagServiceItem.servant)
                return vm.orderBagServiceItem.servant.id;
            else
                return null;
        }

        function availableDates_changed() {
            loadAvailableTimes();
        }

        function loadAvailableTimes() {
            if (vm.selectedDate == undefined || vm.selectedDate == null)
                return;

            var dateTime = new Date(vm.selectedDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            vm.availableTimes = ServiceTimeSessionCustom.getAvailableServiceTimeSessionsInOneDate(vm.serviceItemId, dateTime.toISOString()).query();

        }

    }
})();
